import { render, staticRenderFns } from "./CodigoPostalForm.vue?vue&type=template&id=0872704f&"
import script from "./CodigoPostalForm.vue?vue&type=script&lang=js&"
export * from "./CodigoPostalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports